export default "__VITE_ASSET__C0_u61xP__"